import { CreateAnnouncementDto, CreateFeedbackDto, IAnnouncement, IFeedback } from 'admiral-core';
import { AxiosResponse } from 'axios';
import { AdmiralApi, BASE_URL } from '@/services/AdmiralApi';

export class FeedbackApi {
  static getFeedbacks(): Promise<AxiosResponse<IFeedback[]>> {
    return AdmiralApi.apiCall<IFeedback[]>({
      method: 'POST',
      url: `${BASE_URL}/feedback`,
    });
  }

  static getFeedback(id: string): Promise<AxiosResponse<IFeedback>> {
    return AdmiralApi.apiCall<IFeedback>({
      method: 'POST',
      url: `${BASE_URL}/feedback/${id}`,
    });
  }

  static create(createFeedbackDto: CreateFeedbackDto): Promise<AxiosResponse> {
    return AdmiralApi.apiCall({
      method: 'POST',
      url: `${BASE_URL}/feedback/create`,
      data: createFeedbackDto,
    });
  }
}
